export const formatDataToDDMMYY = (data: string): string => {
  return data.split('T')[0].split('-').reverse().join('.');
};
